import React from 'react';
import protoaiData from '../data/protoai-data.json';

// コンポーネントのインポート
import ProtoHero from './components-protoai/ProtoHero';
import ProblemSection from './components-protoai/ProblemSection';
import SolutionSection from './components-protoai/SolutionSection';
import ValueProposition from './components-protoai/ValueProposition';
import FastDevService from './components-protoai/FastDevService';
import NurturingDevService from './components-protoai/NurturingDevService';
import PricingPlans from './components-protoai/PricingPlans';
import ProcessFlow from './components-protoai/ProcessFlow';
import CaseStudies from './components-protoai/CaseStudies';
import FAQSection from './components-protoai/FAQSection';
import AboutSection from './components-protoai/AboutSection';
import ContactSection from './components-protoai/ContactSection';

const ComponentCatalog = () => {
  // ページ内ナビゲーション用のコンポーネントリスト
  const components = [
    { id: 'hero', name: 'Hero Section', label: 'ヒーローセクション' },
    { id: 'problem', name: 'Problem Section', label: '課題提起セクション' },
    { id: 'solution', name: 'Solution Section', label: 'ソリューションセクション' },
    { id: 'value', name: 'Value Proposition', label: '価値提案セクション' },
    { id: 'fastdev', name: 'Fast Dev Service', label: '超高速プロトタイピング' },
    { id: 'nurturing', name: 'Nurturing Dev Service', label: '育てるAI開発' },
    { id: 'pricing', name: 'Pricing Plans', label: '料金プラン' },
    { id: 'flow', name: 'Process Flow', label: '導入の流れ' },
    { id: 'cases', name: 'Case Studies', label: '導入事例' },
    { id: 'faq', name: 'FAQ Section', label: 'よくある質問' },
    { id: 'about', name: 'About Section', label: '私たちについて' },
    { id: 'contact', name: 'Contact Section', label: 'お問い合わせ' },
  ];

  return (
    <div className="component-catalog">
      {/* ページヘッダー */}
      <div className="catalog-header bg-dark text-white p-50px">
        <div className="container">
          <h1 className="display-4 font-weight-bold m-20px-b">コンポーネントカタログ</h1>
          <p className="lead">protoAI.jp サイトの全コンポーネント一覧</p>
        </div>
      </div>

      {/* 目次ナビゲーション */}
      <div className="catalog-navigation sticky-top bg-white shadow-sm p-20px">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h5 className="font-weight-bold m-15px-b">クイックナビゲーション</h5>
              <div className="nav-links d-flex flex-wrap">
                {components.map((comp) => (
                  <a
                    key={comp.id}
                    href={`#${comp.id}`}
                    className="btn btn-sm btn-outline-primary m-5px"
                  >
                    {comp.label}
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* コンポーネント表示エリア */}
      <div className="catalog-content">
        {/* ===== HERO SECTION ===== */}
        <div id="hero" className="component-wrapper">
          <div className="component-header bg-light p-30px">
            <div className="container">
              <span className="component-number badge badge-primary p-10px">01</span>
              <h2 className="component-label d-inline-block m-15px-l">Hero Section - ヒーローセクション</h2>
              <p className="component-description text-muted m-10px-t">トップページのメインビジュアルとキャッチコピー</p>
            </div>
          </div>
          <ProtoHero data={protoaiData.hero} />
        </div>

        {/* ===== PROBLEM SECTION ===== */}
        <div id="problem" className="component-wrapper">
          <div className="component-header bg-light p-30px">
            <div className="container">
              <span className="component-number badge badge-primary p-10px">02</span>
              <h2 className="component-label d-inline-block m-15px-l">Problem Section - 課題提起セクション</h2>
              <p className="component-description text-muted m-10px-t">時間差を事業差に変える3つの価値</p>
            </div>
          </div>
          <ProblemSection data={protoaiData.problem} />
        </div>

        {/* ===== SOLUTION SECTION ===== */}
        <div id="solution" className="component-wrapper">
          <div className="component-header bg-light p-30px">
            <div className="container">
              <span className="component-number badge badge-primary p-10px">03</span>
              <h2 className="component-label d-inline-block m-15px-l">Solution Section - ソリューションセクション</h2>
              <p className="component-description text-muted m-10px-t">AI要件定義アシスタントの説明</p>
            </div>
          </div>
          <SolutionSection data={protoaiData.solution} />
        </div>

        {/* ===== VALUE PROPOSITION ===== */}
        <div id="value" className="component-wrapper">
          <div className="component-header bg-light p-30px">
            <div className="container">
              <span className="component-number badge badge-primary p-10px">04</span>
              <h2 className="component-label d-inline-block m-15px-l">Value Proposition - 価値提案セクション</h2>
              <p className="component-description text-muted m-10px-t">時間とチームの2つの革命</p>
            </div>
          </div>
          <ValueProposition data={protoaiData.valueProposition} />
        </div>

        {/* ===== FAST DEV SERVICE ===== */}
        <div id="fastdev" className="component-wrapper">
          <div className="component-header bg-light p-30px">
            <div className="container">
              <span className="component-number badge badge-primary p-10px">05</span>
              <h2 className="component-label d-inline-block m-15px-l">Fast Dev Service - 超高速プロトタイピング</h2>
              <p className="component-description text-muted m-10px-t">最短当日開発サービスの詳細</p>
            </div>
          </div>
          <FastDevService data={protoaiData.services.fastDev} />
        </div>

        {/* ===== NURTURING DEV SERVICE ===== */}
        <div id="nurturing" className="component-wrapper">
          <div className="component-header bg-light p-30px">
            <div className="container">
              <span className="component-number badge badge-primary p-10px">06</span>
              <h2 className="component-label d-inline-block m-15px-l">Nurturing Dev Service - 育てるAI開発</h2>
              <p className="component-description text-muted m-10px-t">チーム育成と内製化支援</p>
            </div>
          </div>
          <NurturingDevService data={protoaiData.services.nurturingDev} />
        </div>

        {/* ===== PRICING PLANS ===== */}
        <div id="pricing" className="component-wrapper">
          <div className="component-header bg-light p-30px">
            <div className="container">
              <span className="component-number badge badge-primary p-10px">07</span>
              <h2 className="component-label d-inline-block m-15px-l">Pricing Plans - 料金プラン</h2>
              <p className="component-description text-muted m-10px-t">透明性の高い料金体系と協創割引</p>
            </div>
          </div>
          <PricingPlans data={protoaiData.pricing} />
        </div>

        {/* ===== PROCESS FLOW ===== */}
        <div id="flow" className="component-wrapper">
          <div className="component-header bg-light p-30px">
            <div className="container">
              <span className="component-number badge badge-primary p-10px">08</span>
              <h2 className="component-label d-inline-block m-15px-l">Process Flow - 導入の流れ</h2>
              <p className="component-description text-muted m-10px-t">お問い合わせから納品までの7ステップ</p>
            </div>
          </div>
          <ProcessFlow data={protoaiData.flow} />
        </div>

        {/* ===== CASE STUDIES ===== */}
        <div id="cases" className="component-wrapper">
          <div className="component-header bg-light p-30px">
            <div className="container">
              <span className="component-number badge badge-primary p-10px">09</span>
              <h2 className="component-label d-inline-block m-15px-l">Case Studies - 導入事例</h2>
              <p className="component-description text-muted m-10px-t">お客様の成功事例</p>
            </div>
          </div>
          <CaseStudies data={protoaiData.cases} />
        </div>

        {/* ===== FAQ SECTION ===== */}
        <div id="faq" className="component-wrapper">
          <div className="component-header bg-light p-30px">
            <div className="container">
              <span className="component-number badge badge-primary p-10px">10</span>
              <h2 className="component-label d-inline-block m-15px-l">FAQ Section - よくある質問</h2>
              <p className="component-description text-muted m-10px-t">お客様からよくいただく質問と回答</p>
            </div>
          </div>
          <FAQSection data={protoaiData.faq} />
        </div>

        {/* ===== ABOUT SECTION ===== */}
        <div id="about" className="component-wrapper">
          <div className="component-header bg-light p-30px">
            <div className="container">
              <span className="component-number badge badge-primary p-10px">11</span>
              <h2 className="component-label d-inline-block m-15px-l">About Section - 私たちについて</h2>
              <p className="component-description text-muted m-10px-t">企業理念と代表メッセージ</p>
            </div>
          </div>
          <AboutSection data={protoaiData.about} />
        </div>

        {/* ===== CONTACT SECTION ===== */}
        <div id="contact" className="component-wrapper">
          <div className="component-header bg-light p-30px">
            <div className="container">
              <span className="component-number badge badge-primary p-10px">12</span>
              <h2 className="component-label d-inline-block m-15px-l">Contact Section - お問い合わせ</h2>
              <p className="component-description text-muted m-10px-t">お問い合わせフォームと連絡先情報</p>
            </div>
          </div>
          <ContactSection data={protoaiData.contact} />
        </div>
      </div>

      {/* トップへ戻るボタン */}
      <div className="back-to-top-wrapper p-50px text-center bg-dark">
        <button
          onClick={() => window.scrollTo({top: 0, behavior: 'smooth'})}
          className="btn btn-default btn-filled btn-lg animated-btn"
        >
          <i className="icofont-arrow-up"></i> トップへ戻る
        </button>
      </div>
    </div>
  );
};

export default ComponentCatalog;